import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the circle outline icon
 * 
 * @param {Object} props - The props of the component
 * @returns The circle outline icon
 */
const CircleOutlineIcon = (props) => (
  <Icon viewBox="0 0 5 5" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="1">
      <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
      <circle cx="2.5" cy="2.5" r="2" fill="none" />
    </g>
  </Icon>
);

export default React.memo(CircleOutlineIcon);
